import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiInbox, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { CustomerCenterService } from "../../../services";
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import LineImg from '../../../assets/img/customer-service-center/L-img.png';
import Aimg from '../../../assets/img/customer-service-center/a.png';

const FAQ = () => {
  const navigate = useNavigate();
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedItems, setExpandedItems] = useState(new Set());

  const fetchFaqData = async () => {
    try {
      setLoading(true);
      const apiData = await CustomerCenterService.getFaqList();
      setFaqData(apiData.length > 0 ? apiData : []);
    } catch (err) {
      console.error('Failed to fetch FAQ:', err);
      setFaqData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqData();
  }, []);

  const handleInquiryClick = () => {
    navigate('/contact-us');
  };

  const toggleFaqItem = (id) => {
    const newExpandedItems = new Set();
    if (!expandedItems.has(id)) {
      newExpandedItems.add(id);
    }
    setExpandedItems(newExpandedItems);
  };

  return (
    <>
      <div className="announcement-list-page">
        <TopSetion />

        {/* Main Content */}
        <main className="main-content">
          <SubHeading heading="자주하는 질문" />

          {/* FAQ Section */}
          <section className="announcement-section">
            {loading && faqData.length === 0 ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>자주하는 질문을 불러오는 중...</p>
              </div>
            ) : faqData.length === 0 ? (
              <div className="empty-state">
                <FiInbox className="empty-icon" size={64} />
                <div className="empty-title">등록된 공지사항이 없습니다</div>
                <div className="empty-description">
                  새로운 공지사항이 등록되면 이곳에 표시됩니다.
                </div>
              </div>
            ) : (
              <>
                {/* FAQ Container */}
                <div className="faq-container">
                  <div className="faq-list">
                    {faqData.map((faq) => (
                      <div 
                        key={faq.boardId} 
                        className={`faq-item ${expandedItems.has(faq.boardId) ? 'expanded' : ''}`}
                      >
                        <div
                          className="faq-question"
                          onClick={() => toggleFaqItem(faq.boardId)}
                        >
                          <div className="question-icon">Q</div>
                          <span className="question-text">{faq.boardTitle}</span>
                          <div className="faq-icon mobile-toggle">
                            {expandedItems.has(faq.boardId) ? (
                              <span className="toggle-icon">-</span>
                            ) : (
                              <span className="toggle-icon">+</span>
                            )}
                          </div>
                        </div>
                        {expandedItems.has(faq.boardId) && (
                          <div className="faq-answer">
                            <div className="answer-icon">
                              {/* <img src={LineImg} alt="Line" className="line-img" />  */}
                              <div className="answer-icon-text">A</div>
                            </div>
                            <div className="answer-content" dangerouslySetInnerHTML={{ __html: faq.boardContents }} />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Load More Button */}
                <div className="more-button-section">
                  <button
                    className="more-button"
                    onClick={handleInquiryClick}
                  >
                    문의하기
                  </button>
                </div>
              </>
            )}
          </section>
        </main>
      </div>
    </>
  );
};

export default FAQ;